jQuery(document).ready(function ($) {

    // accordion
    let $sectionPanelCollapse = jQuery('.section-custom-accordion .accordion-collapse, .section-custom-accordion-type-2 .accordion-collapse');
    $sectionPanelCollapse.on('show.bs.collapse', function () {
        jQuery(this).parent().addClass('opened');
    });
    $sectionPanelCollapse.on('hide.bs.collapse', function () {
        jQuery(this).parent().removeClass('opened');
    });


    // Search
    const $section = $('.section-custom-accordion, .section-custom-accordion-type-2');
    if (!$section.length) return;

    $('#faqSearch').on('input', function () {
        const value = $(this).val().toLowerCase().trim();

        // 1. Reset: Restore all HTML and state
        $section.find('.title, .child-title, .accordion-body').each(function () {
            const $el = $(this);
            if ($el.data('original-html') !== undefined) {
                $el.html($el.data('original-html'));
            }
        });

        if (value === '') {
            $section.find('.accordion-item').show();
            $section.find('.accordion-collapse').removeClass('show');
            $section.find('.accordion-button').addClass('collapsed').attr('aria-expanded', 'false');
            return;
        }

        // 2. Hide everything initially for search
        $section.find('.accordion-item').hide();
        $section.find('.accordion-collapse').removeClass('show');
        $section.find('.accordion-button').addClass('collapsed').attr('aria-expanded', 'false');

        const regex = new RegExp(`(${value})(?![^<]*>)`, 'gi');

        // 3. Process each item
        $section.find('.accordion-item').each(function () {
            const $item = $(this);
            const $title = $item.find('> .accordion-header .title, > .accordion-header .child-title');
            const $body = $item.find('> .accordion-collapse .accordion-body');
            const hasNested = $body.find('.accordion').length > 0;

            // Store original HTML if not already stored
            if ($title.length && $title.data('original-html') === undefined) $title.data('original-html', $title.html());
            if ($body.length && $body.data('original-html') === undefined) $body.data('original-html', $body.html());

            let isMatched = false;

            // Check match in title
            if ($title.length && $title.text().toLowerCase().indexOf(value) > -1) {
                isMatched = true;
                $title.html($title.data('original-html').replace(regex, '<mark>$1</mark>'));
            }

            // Check match in body (only for leaf items to avoid breaking nested structures)
            if (!hasNested && $body.length && $body.text().toLowerCase().indexOf(value) > -1) {
                isMatched = true;
                $body.html($body.data('original-html').replace(regex, '<mark>$1</mark>'));
            }

            if (isMatched) {
                // Show and open this item
                $item.show();
                const $collapse = $item.find('> .accordion-collapse');
                const $button = $item.find('> .accordion-header > .accordion-button');
                $collapse.addClass('show');
                $button.removeClass('collapsed').attr('aria-expanded', 'true');

                // Show and open ALL parents
                $item.parents('.accordion-item').show().each(function () {
                    const $parent = $(this);
                    const $pCollapse = $parent.find('> .accordion-collapse');
                    const $pButton = $parent.find('> .accordion-header > .accordion-button');
                    $pCollapse.addClass('show');
                    $pButton.removeClass('collapsed').attr('aria-expanded', 'true');
                });
            }
        });
    });

});

